const COMMENTS = [
  {
    name: '吃瓜群众A',
    avatar: '瓜',
    time: '2小时前',
    content: '这个吃瓜网站线路一真的太方便了！之前找51吃瓜入口总是迷路，现在直接收藏这个页面，每天打开就能看到最新内容，更新速度比我想象的快多了。',
    likes: '128',
  },
  {
    name: '八卦小能手',
    avatar: '八',
    time: '5小时前',
    content: '作为资深吃瓜人，吃瓜网站线路一的内容质量确实高。不仅有时效性强的快讯，还有深度分析文章，吃瓜网站首页的专题合集整理得特别清晰。',
    likes: '96',
  },
  {
    name: '围观路人',
    avatar: '围',
    time: '1天前',
    content: '朋友推荐的51吃瓜网址，试了一周感觉不错。匿名浏览的设计很贴心，不用担心隐私问题。已经设为浏览器首页了，每天上班先逛一圈。',
    likes: '74',
  },
  {
    name: '深夜吃瓜人',
    avatar: '夜',
    time: '2天前',
    content: '熬夜党的福音！半夜刷到的大瓜第二天早上就在吃瓜网站首页看到了详细整理，51吃瓜官网全网最新的名号名副其实，收藏不亏。',
    likes: '53',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            吃瓜人说
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            看看其他吃瓜群众对51吃瓜网站的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-4xl mx-auto">
          {COMMENTS.map((item) => (
            <div
              key={item.name}
              className="bg-background-100 rounded-xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-primary-100 flex items-center justify-center text-sm font-bold text-primary-600 flex-shrink-0">
                  {item.avatar}
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-heart-line text-primary-500"></i>
                </span>
                {item.likes}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}